// extracted by mini-css-extract-plugin
module.exports = {"about-panel":"AboutSettings-module__about-panel___3ISHw","process-monitor-button":"AboutSettings-module__process-monitor-button___2whnT"};